<template>
    <v-dialog v-model="value" persistent content content-class="centered-dialog">
      <v-container fill-height>
        <v-layout column justify-center align-center>
          <v-progress-circular class='' indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
</template>

<script>
  export default {
    name: 'TheLoadingOverlay',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
<style>
.dialog.centered-dialog,
.v-dialog.centered-dialog
{
  background: #282c2dad;
  box-shadow: none;
  border-radius: 6px;
  width: auto;
  color: whitesmoke;
}
</style>



// WEBPACK FOOTER //
// src/components/TheLoadingOverlay.vue